<template>
  <section class="dashboard">
    <div class="page-header">
      <h3 class="page-title">Standorte</h3>
    </div>

    <div class="row">
      <div class="col-12 grid-margin">
        <i v-if="loading" class="fa fa-cog fa-spin" style="font-size: 50px"></i>
        <div class="card" v-if="!loading">
          <div class="card-body">
            <h4 class="card-title">Einrichtungen ({{ locations.length }})</h4>
            <b-form-select v-if="!isCustomer" v-model="stateFilter" :options="account_states"
              style="margin-bottom: 20px" />

            <form class="forms-sample" v-if="!isCustomer">
              <b-form-group label="" label-for="input1">
                <b-form-input v-model="invoicefilter" type="text" id="input1"
                  placeholder="Träger oder Einrichtung..."></b-form-input>
              </b-form-group>

              <div class="row">
                <div class="col-md-4">
                  <b-form-group style="margin-bottom: 40px;">
                    <b-form-checkbox v-model="sepaFilter" switch>
                      Nur SEPA-Mandate
                    </b-form-checkbox>
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group style="margin-bottom: 40px;">
                    <b-form-checkbox v-model="settlementFilter" switch>
                      Abrechnungen in der Zukunft ausblenden
                    </b-form-checkbox>
                  </b-form-group>
                </div>
              </div>
            </form>
            <div v-title="'Somethings...'"></div>
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th style="cursor: pointer;" v-if="!isCustomer" @click="sortBy('category')">Träger</th>
                    <th style="cursor: pointer;" v-if="!isCustomer" @click="sortBy('created_at')">Erstellt</th>
                    <th style="cursor: pointer;" @click="sortBy('name')">Einrichtung</th>

                    <th style="cursor: pointer;" @click="sortBy('next_settlement_stamp')">Nächste Abrechnung</th>
                    <th>Rechnungen</th>
                    <th></th>
                    <th style="cursor: pointer;" @click="sortBy('billing_sepa')">SEPA</th>
                    <th></th>
                    <th v-if="isCustomer"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in sortedLocations" :key="item.uid">
                    <td v-if="!isCustomer">
                      <a class="link-col" :href="generateLink(item.uid)" target="_blank">{{ item.category }}</a>
                    </td>
                    <td v-if="!isCustomer">
                      {{ item.created_at | moment(" D.MM.YYYY") }}
                    </td>
                    <td>
                      <a class="link-col" :href="generateLink(item.uid)" target="_blank">{{ item.name }}</a>
                    </td>
                    <td>
                      {{ item.next_settlement }}
                    </td>
                    <td>
                      {{ item.billings_count }}

                      ({{ item.unpaid_invoices }})
                      <i v-if="item.billing_alert && item.billing_alert == 'y'" class="fa fa-check"
                        style="margin-left: 5px" aria-hidden="true"></i>
                    </td>
                    <td>
                      <div v-if="item.notice && item.notice.length > 1" v-title="item.notice"><i
                          class="mdi  mdi-24px  mdi-clipboard-alert" style="color:#12CEB2;cursor:pointer;" /></div>
                    </td>
                    <td>
                      <i v-if="item.billing_sepa && item.billing_sepa == 'y'" class="fa fa-check"
                        style="margin-left: 5px" aria-hidden="true"></i>
                    </td>
                    <td>
                      <div v-for="item_account in item.account_tags" :key="item_account" class="badge-container">
                        <span class="badge-tag">{{ item_account }}</span>
                      </div>
                    </td>
                    <td style="text-align: right" v-if="isCustomer">
                      <router-link v-if="isCustomer" class="btn btn-outline-primary btn-fw" :to="{
                        name: 'location-customer',
                        params: { uid: item.uid },
                      }">Anzeigen</router-link>
                      <router-link v-if="!isCustomer" target="_blank" class="btn btn-outline-primary btn-fw" :to="{
                        name: 'location-detail',
                        params: { uid: item.uid },
                      }">Anzeigen</router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { getAll } from "@/services/locations.service";

export default {
  name: "dashboard",
  components: {},
  data() {
    return {
      stateFilter: "customer",
      loading: true,
      sepaFilter: false,
      settlementFilter: false,
      invoicefilter: null,
      sortKey: 'name', // Standard-Sortierschlüssel
      sortOrder: 'asc', // Sortierreihenfolge: 'asc' oder 'desc'
      account_states: [
        { text: "Test", value: "test" },
        { text: "Kunde", value: "customer" },
        { text: "Kostenlose Nutzung", value: "forfree" },
        { text: "Geschlossen", value: "close" },

      ],
    };
  },
  computed: {
    sortedLocations: function () {
      let locations = this.locations; // Nutzen Sie Ihre vorhandene locations Methode

      // Sortierung durchführen, falls ein Sortierschlüssel vorhanden ist
      if (this.sortKey) {
        locations = locations.slice().sort((a, b) => {
          let valA = a[this.sortKey];
          let valB = b[this.sortKey];

          if (typeof valA === 'string' && typeof valB === 'string') {
            valA = valA.toLowerCase();
            valB = valB.toLowerCase();
          }

          if (this.sortOrder === 'asc') {
            return valA > valB ? 1 : valA < valB ? -1 : 0;
          } else {
            return valA < valB ? 1 : valA > valB ? -1 : 0;
          }
        });
      }

      return locations;
    },
    locations: function () {
      if (!this.$store.state.locations) {
        return;
      }

      return this.$store.state.locations.filter((item) => {
        // SEPA Filter
        const sepaMatch = !this.sepaFilter || (item.billing_sepa === 'y');

        // Settlement Filter
        const settlementMatch = !this.settlementFilter || (() => {
          if (!item.next_settlement) return false;

          // Datum aus String parsen (DD.MM.YYYY)
          const [day, month, year] = item.next_settlement.split('.');
          const settlementDate = new Date(year, month - 1, day); // month - 1 weil JS Monate bei 0 beginnen
          const today = new Date();

          // Setze Zeit auf 00:00:00 für korrekten Vergleich
          today.setHours(0, 0, 0, 0);
          settlementDate.setHours(0, 0, 0, 0);

          return settlementDate <= today;
        })();

        // Bestehende Filter
        const stateMatch = item.account_state == this.stateFilter;
        const searchMatch = !this.invoicefilter ||
          (item.category &&
            item.category
              .toString()
              .toLowerCase()
              .indexOf(this.invoicefilter.toLowerCase()) != -1) ||
          (item.name &&
            item.name
              .toString()
              .toLowerCase()
              .indexOf(this.invoicefilter.toLowerCase()) != -1);

        // Kombiniere alle Filter
        return stateMatch && searchMatch && sepaMatch && settlementMatch;
      });
    },
    isCustomer: function () {
      return (
        this.$store.state.user_customer &&
        this.$store.state.user_company &&
        this.$store.state.user_company.length > 2
      );
    },
  },
  methods: {
    sortBy: function (key) {
      this.sortKey = key;
      this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
    },
    generateLink(uid) {
      return this.$router.resolve({
        name: 'location-detail',
        params: { uid }
      }).href;
    }
  },
  filters: {
    uppercase: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.toUpperCase();
    },
    capitalize: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },
  mounted() {
    this.loading = true;

    getAll().then((resp) => {
      this.loading = false;
      console.log(resp, "-");
      if (resp.data.error) {
        localStorage.removeItem("token");
        this.$router.push({ name: "login" });
      } else {
        this.$store.state.locations = resp.data.locations;
        this.$store.state.user_customer = resp.data.customer;
        this.$store.state.user_company = resp.data.company;


        for (let i = 0; i < this.$store.state.locations.length; i++) {

          if (!this.$store.state.locations[i].billing_sepa || this.$store.state.locations[i].billing_sepa != "y") {
            this.$store.state.locations[i].billing_sepa = "n"
          }

        }

      }
    }).catch(() => {
      localStorage.removeItem("token");
      this.$router.push({ name: "login" });
    });
  },
};
</script>

<style scoped>
.badge-container {
  margin-bottom: 5px;
}

.badge-tag {
  color: #ffffff;
  background-color: #198ae3;
  padding: 4px 5px 4px 5px;
  font-size: 12px;
  display: inline-block;
}

.link-col {
  color: #0077cc;
  /* Standardfarbe für "unbesucht" */
  text-decoration: none;
  /* Beispiel: kein Unterstreichen */
}

/* Hover-Zustand */
.link-col:hover {
  color: #005fa3;
  /* Wenn der Mauszeiger über dem Link ist */
}

/* Visited-Zustand */
.link-col:visited {
  color: #551A8B;
  /* Farbe für bereits besuchte Links */
}
</style>